// This header needs to be set because of that: https://answers.sap.com/answers/12782775/view.html
export const HEADER_CONTENT_TYPE_FORM_URLENCODED = {
  'content-type': 'application/x-www-form-urlencoded'
};
export const HEADER_CONTENT_TYPE_APPLICATION_JSON = {
  'content-type': 'application/json'
};

export enum API_FIELDS {
  BASIC = 'BASIC',
  DEFAULT = 'DEFAULT',
  FULL = 'FULL'
}

export const ANONYMOUS_USER = 'anonymous';
export const AUTHENTICATED_USER = 'current';

export const AUTH_USER_TOKEN_COOKIE_NAME = 'vsf-sap-token';
export const AUTH_USER_COOKIE_NAME = 'vsf-user';
export const AUTH_APPLICATION_TOKEN_COOKIE_NAME_SET =
  'auth-application-token-set';
export const AUTH_USER_TOKEN_COOKIE_NAME_SET = 'vsf-sap-token-set';
export const USER_COOKIE_NAME = 'user';

export const CART_ID_COOKIE_NAME = 'CART_ID';
export const CART_WISHLIST = 'cart-wishlist';
export const AXIOS_TOKEN_TYPE_HEADER_NAME = 'x-token-type';
export const AXIOS_RETRIES_LEFT_HEADER_NAME = 'x-retries-left';

/**
 * A variable holding a list of order fields that can be fetched
 * for anonymous users.
 */
export const ALLOWED_GUEST_ORDER_FIELDS = [
  'appliedOrderPromotions(FULL)',
  'appliedProductPromotions(FULL)',
  'appliedVouchers(FULL)',
  'deliveryCost',
  'deliveryItemsQuantity',
  'deliveryMode(FULL)',
  'code',
  'guid',
  'entries(FULL)',
  'guestCustomer',
  'net',
  'orderDiscounts(FULL)',
  'pickupItemsQuantity',
  'pickupOrderGroups',
  'productDiscounts(FULL)',
  'returnable',
  'site',
  'status',
  'deliveryAddress(title)',
  'statusDisplay',
  'store',
  'subTotal(FULL)',
  'totalDiscounts(FULL)',
  'totalItems',
  'totalPrice(FULL)',
  'totalPriceWithTax(FULL)',
  'totalTax(FULL)',
  'unconsignedEntries(FULL)',
  'user(uid)'
].join(',');
